import { Component, Inject, ViewEncapsulation, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { rescheduleI } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCalendarCellClassFunction, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { addressI } from 'app/core/interfaces/adress';
import { organizationI } from 'app/core/interfaces/organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { PatientService } from 'app/core/http/services/patient.service';
import { telecom } from 'app/core/models/Organization';
import { Encounter } from 'app/core/interfaces/encounter';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { Agreements, HealthcarePlans, PaymentSettings } from 'app/core/interfaces/payment-settings';
import { TimeSlot } from 'app/core/interfaces/practitionerHours';
import { DialogService } from 'app/services/dialog.service';
import { MedicationRequestService } from 'app/core/http/services/medicationrequest.service';
import { Prescription, Medications } from 'app/core/interfaces/prescriptions';
import { ChangeScheduleMethodComponent } from 'app/modules/shared/components/change-schedule-method/change-schedule-method.component';
import { HttpErrorResponse } from '@angular/common/http';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { PaymentService } from 'app/core/http/services/payment.service';
import { Payment } from 'app/core/interfaces/payment';

@Component({
  selector: 'page-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }],
  encapsulation: ViewEncapsulation.None,
})
export class PatientScheduleDetailsComponent extends BaseComponent implements OnInit {
  public status = 0;
  public horariosExame = 10;
  public horariosConsulta = 10;
  public titleDados = 'Dados do Paciente';
  public titleReschedule = 'Reagendamento';
  public address: addressI = <addressI>{};
  public organization: any = <organizationI>{};
  public hours: any[] = [];
  public dates: any[] = [];
  public hour: rescheduleI = <rescheduleI>{};
  public organizationLocation: any;
  public latLong: [number, number] = [0, 0];
  public encounterFHIR: any;
  public encounter: any;
  public schedule: any;
  public type: string = '';
  public patient: any;
  public dayOfWeekSelected: string = '';
  public weeklySchedule: { [key: string]: TimeSlot[] } = {};
  public encounterPractitioner!: Encounter[];
  public encountersDone: any = {};
  public disabledTimes: string[] = [];
  public today = new Date();
  public organizationSettings!: PaymentSettings;
  public healthPlansOrganization: HealthcarePlans[] = [];
  public healPlanAgreement: Agreements[] = [];
  public scheduleMethod: string = '';
  public prescription: Prescription[] = [];
  public medications: Medications[] = [];
  public titleMedications = 'Medicamentos';
  public uploadedFiles: { name: string; base64: string }[] = [];
  public isDragging = false;
  public blockedDates: string[] = [];
  public isByOrder: boolean = false;
  public paymentData?: Payment;

  public daysOfWeek = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];

  public practitioner!: Practitioner;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private encounterService: EncounterService,
    private patientService: PatientService,
    private affiliationOrganizationPractitioner: PractitionerOrganizationAffiliationService,
    private organizationLocationService: OrganizationLocationService,
    private medicationRequest: MedicationRequestService,
    private practitionerService: PractitionerService,
    private dialogService: DialogService,
    private paymentService: PaymentService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    let parameters = this.data.param;

    if (parameters.encounter) {
      this.encounter = parameters.encounter as Encounter;
      this.encounterFHIR = parameters.encounterFHIR;
      this.scheduleMethod = parameters.encounterFHIR.scheduling_method;
      this.type = 'encounter';
    }

    const practitioner_id = this.encounter.practitioner.practitioner_id;
    const organization_id = this.encounter.organization.organization_id;

    this.getPatient();
    this.getPayment();
    this.getOrganizationLocation();
    this.getEncounterPrescriptions();
    this.initializeData();

    if (this.isSpecialistDealer()) {
      this.getEncounterByPractitioner(practitioner_id);
      this.getPractitioner(practitioner_id);
      this.getHoursOfOperation();
    }

    if (this.isOrganizationDealer()) {
      this.getHourByOrganization();
      this.getEncounterByOrganization(organization_id);
    }
  }

  getPayment(): void {
    if (!this.encounter?.encounter_id) return;

    this.paymentService.listByEncounter(this.encounter.encounter_id).subscribe({
      next: (payment: Payment) => (this.paymentData = payment),
      error: () => (this.paymentData = undefined),
    });
  }

  formatPaidPaymentMethod(payment: Payment): string {
    return payment.billingType === 'CREDIT_CARD' ? 'Cartão de crédito' : payment.billingType === 'PIX' ? 'PIX' : payment.payment_method || '-';
  }

  formatPaidPaymentValue(value?: string): string {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return value || '-';
    return (numericValue / 100).toFixed(2).replace('.', ',');
  }

  formatPaidPaymentDate(payment: Payment): string {
    const value = payment.confirmed_at || payment.payment_at || this.encounter?.payment_at;
    if (!value) return '-';
    const normalized = String(value).replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}):(\d+)$/, '$1T$2.$3');
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  }

  getDayName(dayOfWeek: number): string {
    return this.daysOfWeek[dayOfWeek];
  }

  isOrganizationDealer() {
    return this.encounter.organization.organization_id == this.encounter.practitioner.practitioner_id;
  }

  isSpecialistDealer() {
    return this.encounter.organization.organization_id != this.encounter.practitioner.practitioner_id;
  }

  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const date = moment(d).format('YYYY-MM-DD');
    if (this.blockedDates.includes(date)) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (d < today) return false;

    const dayName = this.getDayName(d.getDay());
    return !!this.weeklySchedule[dayName]?.length;
  };

  organizationDateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (d < today) return false;

    const key = moment(d).format('YYYY-MM-DD');
    if (this.blockedDates.includes(key)) return false;

    const dayName = this.getDayName(d.getDay());
    const hasSlots = Array.isArray(this.weeklySchedule[dayName]) && this.weeklySchedule[dayName].length > 0;
    return hasSlots;
  };

  isTimeDisabled(time: string): boolean {
    if (!this.hour.date) return true;

    const dateKey = moment(this.hour.date).format('YYYY-MM-DD');
    const isPastTime = this.disabledMinuts(time);
    const isBookedTime = this.disabledTimes.includes(time);
    const isBlockedDate = this.blockedDates.includes(dateKey);

    return isPastTime || isBookedTime || isBlockedDate;
  }

  disabledMinuts = (selectedHour: string): boolean => {
    const dateIso = moment(this.hour.date).format('YYYY-MM-DD');
    const dateTime = `${dateIso} ${selectedHour}:00`;
    return moment(dateTime, 'YYYY-MM-DD HH:mm:ss').isBefore(moment());
  };

  public isBlockedDate(d: Date | null): boolean {
    if (!d) return false;
    const key = moment(d).format('YYYY-MM-DD');
    return this.blockedDates.includes(key);
  }

  private getPractitioner(practitioner_id: string): void {
    this.practitionerService.showNew(practitioner_id).subscribe({
      next: (practitioner) => {
        this.practitioner = practitioner;

        const days = Array.isArray(practitioner.modifiedDays) ? practitioner.modifiedDays : [];
        this.blockedDates.push(...days.map((d) => new Date(d.date).toISOString().split('T')[0]));
      },
      error: (err) => console.log(err),
    });
  }

  private initializeData(): void {
    if (this.data.param?.encounter) {
      this.isByOrder = this.data.param.encounter.byOrderInfo?.isByOrder || false;
    }
  }

  private getEncounterPrescriptions() {
    this.medicationRequest.showByEncounter(this.encounter.encounter_id).subscribe({
      next: (prescription: any) => {
        this.prescription = prescription[0];
        this.medications = prescription[0].prescriptions;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getPatient() {
    const patient_id = this.encounter.patient.patient_id;

    this.patientService.show(patient_id).subscribe({
      next: (resPatient: any) => {
        this.patient = resPatient;

        let address = this.patient?.address[0] ? this.patient?.address[0] : this.patient?.address;
        this.patient.address = this.formatAddress(address);

        const contact = this.extractContactInfo(this.patient.telecom ?? []);

        if (contact) {
          this.patient.phone = contact?.phone ?? '';
          this.patient.mobile = contact?.mobile ?? '';
          this.patient.mail = contact?.email ?? '';
        }

        this.patient.cpf = this.patient?.identifier[0]?.value;
      },
      error: (err) => {
        console.log('ERRO', err);
      },
    });
  }

  onDateChange(event: MatDatepickerInputEvent<Date>): void {
    const selectedDate = event.value;

    if (selectedDate) {
      const dateKey = moment(selectedDate).format('YYYY-MM-DD');
      this.disabledTimes = this.encountersDone[dateKey] || [];

      const dayIndex = selectedDate.getDay();
      this.dayOfWeekSelected = this.getDayName(dayIndex);
      this.hours = this.weeklySchedule[this.dayOfWeekSelected] || [];

      if (this.isByOrder && this.hours.length > 0) {
        const firstAvailable = this.hours.find((slot) => !this.isTimeDisabled(slot.timeStart));
        this.hour.time = firstAvailable?.timeStart || null;
      }
    } else {
      this.hours = [];
      this.hour.time = '';
    }
  }

  generateTimeSlots(dayOfWeek: number, startHour: string, endHour: string, slotDuration: number): TimeSlot[] {
    let slots: TimeSlot[] = [];

    let startTime = new Date(`1970-01-01T${startHour}:00`);
    const endTime = new Date(`1970-01-01T${endHour}:00`);

    while (startTime < endTime) {
      let endTimeSlot = new Date(startTime.getTime() + slotDuration);

      if (endTimeSlot <= endTime) {
        slots.push({
          dayOfWeek,
          timeStart: startTime.toTimeString().slice(0, 5),
          timeEnd: endTimeSlot.toTimeString().slice(0, 5),
        });
      }

      startTime = endTimeSlot;
    }

    return slots;
  }

  getDayOfWeek(dia: string): number {
    const daysOfWeek: { [key: string]: number } = {
      Segunda: 1,
      Terca: 2,
      Quarta: 3,
      Quinta: 4,
      Sexta: 5,
      Sabado: 6,
      Domingo: 0,
    };
    return daysOfWeek[dia];
  }

  getHourByOrganization() {
    const encounter = this.encounter as Encounter;
    const orgId = encounter.organization.organization_id;

    const daysOfWeek = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];

    this.weeklySchedule = {};
    this.hours = [];

    const avgDurMs = ((this.encounter.averageDuration ?? 30) as number) * 60 * 1000;

    this.organizationLocationService.showByOrganization(orgId).subscribe({
      next: (org: any) => {
        org.hoursOfOperation.forEach((op: { dayOfWeek: number; timeStart: string; timeEnd: string }) => {
          if (!op.timeStart || !op.timeEnd) return;

          const slots = this.generateTimeSlots(op.dayOfWeek, op.timeStart, op.timeEnd, avgDurMs);
          const dayName = daysOfWeek[op.dayOfWeek];

          this.weeklySchedule[dayName] = [...(this.weeklySchedule[dayName] || []), ...slots];
        });

        if (this.dayOfWeekSelected) {
          this.hours = this.weeklySchedule[this.dayOfWeekSelected] || [];
        }
      },
      error: (err) => console.error(err),
    });
  }

  getHoursOfOperation() {
    const encounter = this.encounter as Encounter;
    const organizationId = encounter.organization.organization_id;
    const practitionerId = encounter.practitioner.practitioner_id;

    this.weeklySchedule = {};
    this.hours = [];

    const averageDuration = (this.encounter.averageDuration ?? 30) as number;
    const slotDuration = averageDuration * 60 * 1000;

    this.affiliationOrganizationPractitioner.listByPractitionerOrganization(organizationId, practitionerId).subscribe({
      next: (affiliation: any) => {
        const practitionerHours = affiliation.specialty.filter((specialty: any) => specialty.id === this.encounterFHIR.specialty[0].coding[0].code);

        practitionerHours[0].practitionerHours.forEach((dayInfo: any) => {
          if (dayInfo.active) {
            const dayOfWeek = this.getDayOfWeek(dayInfo.dia);
            const { hours } = dayInfo;

            this.weeklySchedule[dayInfo.dia] = [];

            hours.forEach((hour: any) => {
              const timeSlots = this.generateTimeSlots(dayOfWeek, hour.startHour, hour.endHour, slotDuration);
              this.weeklySchedule[dayInfo.dia].push(...timeSlots);
            });
          }
        });

        if (this.dayOfWeekSelected) {
          this.hours = this.weeklySchedule[this.dayOfWeekSelected];
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getOrganizationLocation() {
    const organizationId = this.encounter.organization.organization_id;

    this.organizationLocationService.showByOrganization(organizationId).subscribe({
      next: (resOrganizationLocation) => {
        this.organizationLocation = resOrganizationLocation;

        let address = this.organizationLocation?.address[0] ? this.organizationLocation?.address[0] : this.organizationLocation?.address;
        this.organizationLocation.address = this.formatAddress(address);

        this.latLong = [this.organizationLocation.position.latitude ?? 0, this.organizationLocation.position.longitude ?? 0];

        const days = Array.isArray(this.organizationLocation.organization.modifiedDays) ? this.organizationLocation.organization.modifiedDays : [];
        this.blockedDates.push(...days.map((d: any) => new Date(d.date).toISOString().split('T')[0]));
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }

  getEncounterByOrganization(organization_id: string) {
    this.encountersDone = [];

    this.encounterService.listByOrganizationNew(organization_id).subscribe({
      next: (encounter: Encounter[]) => {
        encounter.forEach((encounter: Encounter) => {
          const [date, time] = encounter.startDate.split(' ');

          if (!this.encountersDone[date]) {
            this.encountersDone[date] = [];
          }

          this.encountersDone[date].push(time);
        });
      },
      error: (err) => {
        console.log('Falha ao buscar as organizações', err);
      },
    });
  }

  getEncounterByPractitioner(practitionerId: string) {
    this.encountersDone = [];

    this.encounterService.listByPractitionerNew(practitionerId).subscribe({
      next: (encounter: Encounter[]) => {
        this.encounterPractitioner = encounter;

        encounter.forEach((encounter: Encounter) => {
          const [date, time] = encounter.startDate.split(' ');

          if (!this.encountersDone[date]) {
            this.encountersDone[date] = [];
          }

          this.encountersDone[date].push(time);
        });
      },
      error: (err) => {
        console.log('Falha ao buscar as organizações', err);
      },
    });
  }

  reagendamento() {
    if (!this.hour.date) {
      return;
    }

    const content = this.isByOrder
      ? `Deseja reagendar o atendimento para o dia <b>${moment(this.hour.date).format(
          'DD/MM/YYYY',
        )}</b>? Lembre-se que o atendimento é por horario de chegada`
      : `Deseja reagendar o atendimento para <b>${moment(this.hour.date).format('DD/MM/YYYY')} ${this.hour.time}</b>?`;
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'salvar',
        title: 'Confirmar reagendamento',
        content: content,
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          const startDate = this.isByOrder
            ? moment(this.hour.date).format('YYYY-MM-DD') + ' ' + this.getFirstAvailableSlot()
            : moment(this.hour.date).format('YYYY-MM-DD') + ' ' + this.hour.time;

          if (!startDate) return;

          this.confirmReagendamento(startDate);
        }
      });
  }

  confirmReagendamento(dateStart: string) {
    this.encounterFHIR.plannedStartDate = dateStart;

    this.encounterService.update(this.encounterFHIR.encounter_id, this.encounterFHIR).subscribe({
      next: (resEncounter) => {
        this.openSnackBar('Reagendamento realizado com sucesso!', 'success');
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.openSnackBar('Falha ao realizar reagendamento!', 'error');
        console.log('error', err);
      },
    });
  }

  private getFirstAvailableSlot(): string | null {
    if (!this.hour.date || !this.dayOfWeekSelected) return null;

    const dateKey = moment(this.hour.date).format('YYYY-MM-DD');
    const bookedTimes = this.encountersDone[dateKey] || [];

    const availableSlot = this.weeklySchedule[this.dayOfWeekSelected]?.find(
      (slot) => !bookedTimes.includes(slot.timeStart) && !this.disabledMinuts(slot.timeStart),
    );

    return availableSlot?.timeStart || null;
  }

  addDocument() {
    const files = this.uploadedFiles;

    this.encounterService.addDocument(this.encounterFHIR.encounter_id, files).subscribe({
      next: (resEncounter) => {
        this.openSnackBar('Documentos salvos com sucesso!', 'success');

        this.uploadedFiles = [];
      },
      error: (err) => {
        this.openSnackBar('Falha ao salvar documento', 'error');
        console.error(err);
      },
    });
  }

  deleteDocument(file: any) {
    this.encounterService.removeDocument(this.encounterFHIR.encounter_id, file).subscribe({
      next: (resEncounter) => {
        this.openSnackBar('Documentos salvos com sucesso!', 'success');

        this.uploadedFiles = [];
      },
      error: (err) => {
        this.openSnackBar('Falha ao salvar documento', 'error');
        console.error(err);
      },
    });
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view === 'month') {
      const date = cellDate.getDate();
      return date === 1 || date === 20 ? 'warning-date' : '';
    }
    return '';
  };

  public cancelSchedule() {
    let text = '<b>Exame/Consulta:</b> ';
    text += this.encounter.name;

    text += `<br/><b>Data/Hora:</b> ${this.layout.dateTimeFormat(this.encounter?.plannedStartDate)}`;
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'Cancelar atendimento',
        title: 'Deseja cancelar o atendimento?',
        content: text,
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          this.removeSchedule();
          this.dialogRef.close();
        }
      });
  }

  formatAddress(address: any) {
    if (!address) {
      return [];
    }

    const extraInfos = address?.line ?? [];

    return {
      cep: address.postalCode ?? address.cep,
      city: address.city,
      country: address.country,
      state: address.state,
      street: extraInfos[0] ?? 'N/A',
      number: extraInfos[1] ?? 'N/A',
      complement: extraInfos[2] ?? 'N/A',
    };
  }

  extractContactInfo(telecom: telecom[]) {
    let email: string | null = null;
    let phone: string | null = null;
    let mobile: string | null = null;

    telecom.forEach((telecom) => {
      const { value, use, system } = telecom;

      if (system === 'email') {
        email = value;
      } else if (system === 'phone') {
        phone = value;
      } else if (system === 'mobile') {
        mobile = value;
      }
    });

    return { email, phone, mobile };
  }

  public removeSchedule() {
    this.encounterFHIR.status = 'cancelled';

    this.encounterService.update(this.encounterFHIR.encounter_id, this.encounterFHIR).subscribe({
      next: (resEncounter) => {
        this.openSnackBar('Atendimento cancelado com sucesso!', 'success');

        this.dialogRef.close(true);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }

  openScheduleChangeMethodDialog() {
    const data = {
      param: {
        encounter: this.encounterFHIR,
      },
    };

    this.dialog.openComponentDialog(ChangeScheduleMethodComponent, data);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false; // Remover o estado de "arrastar ativo"

    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const files = Array.from(event.dataTransfer.files);

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64 = reader.result.toString().split(',')[1]; // Pegar apenas o conteúdo base64
            this.uploadedFiles.push({ name: file.name, base64 });
          }
        };
        reader.readAsDataURL(file); // Ler o arquivo como Data URL
      });
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      Array.from(input.files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64 = reader.result.toString();
            this.uploadedFiles.push({ name: file.name, base64 });
          }
        };
        reader.readAsDataURL(file); // Ler o arquivo como Data URL
      });
    }
  }

  removeFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
  }

  viewDocument(fileUrl: string): void {
    // Verifica se a URL é válida
    if (fileUrl) {
      window.open(fileUrl, '_blank'); // Abre o arquivo (ou a URL) em uma nova aba
    } else {
      console.error('URL inválida');
    }
  }

  formatPaymentMethod(paymentMethod: string) {
    switch (paymentMethod) {
      case 'PHYSICAL':
        return 'Dinheiro físico';
      case 'PIX':
        return 'Pix';
      case 'CREDIT_CARD':
        return 'Cartão de crédito';
      default:
        return 'Método de pagamento não identificado';
    }
  }
}
